document.addEventListener("DOMContentLoaded", () => {
  const messages = document.querySelectorAll(".fading-announcement-message");
  let currentIndex = 0;

  // Function to show the next message
  const showNextMessage = () => {
    messages.forEach((message, index) => {
      message.classList.remove("active", "inactive");
      if (index === currentIndex) {
        message.classList.add("active");
      } else {
        message.classList.add("inactive");
      }
    });

    currentIndex = (currentIndex + 1) % messages.length; // Cycle back to the first message
  };

  // Start the cycle
  showNextMessage();
  setInterval(showNextMessage, 5000);
});
